import e from "../_virtual/_plugin-vue_export-helper.js";
import t from "./SchemaPropertyExamples.vue.script.js";
/* empty css                                     */
//#region src/schema/SchemaPropertyExamples.vue
var n = /*#__PURE__*/ e(t, [["__scopeId", "data-v-b3473aa1"]]);
//#endregion
export { n as default };

//# sourceMappingURL=SchemaPropertyExamples.vue.js.map